module.exports = __webpack_public_path__ + "img/level2addon_running_gun_mask.693aa1ab.png";